import React from 'react';
import './style.scss';

const Home = () => {
  return (
    <div className="home-wrapper">
      <div className="title">
        Welcome to awesome packages landing
      </div>
    </div>
  )
}

export default Home;
